import { ConnectKitButton } from 'connectkit';
import metamaskIcon from '../assets/navBar/metamaskIcon.svg';
import metamaskConnectedIcon from '../assets/navBar/metamaskConnectedIcon.svg';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAccount, useBalance } from 'wagmi';
import { formatEther } from 'viem';

const StyledConnectButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
  gap: ${() => ({ xs: '0.3rem', md: '1.5rem' })};
  width: 100%;
  aspect-ratio: 4.32/1;

  &:not(.connected) {
    background: linear-gradient(304.25deg, #274ccc 0.76%, #2985e3 97.81%);
    border: 0.5px solid #a3d1ff;
    box-shadow: 0px 4px 50px rgba(92, 164, 248, 0.5);
    border-radius: 0.5rem;
  }

  &.connected {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 0.75rem;
    gap: 1.5rem;

    & .buttonText {
      font-size: ${() => ({ xs: '0.9rem', md: '1.125rem' })};
    }

    & .balance {
      color: rgba(255, 255, 255, 0.6);
      font-size: ${() => ({ xs: '0.9rem', md: '1.125rem' })};
    }

    @media (max-width: 600px) {
      & .metamaskIcon,
      & .balance {
        display: none;
      }
      gap: 0;
      justify-content: center;
      padding: 0.5rem;
    }
  }

  & .metamaskIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    aspect-ratio: 1/1;
    padding: 0.5rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;

    & img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  & .buttonText {
    font-family: Inter;
    font-weight: 500;
    font-size: 0.92rem;
    line-height: 1.13rem;
    color: #ffffff;
  }
`;

export const ConnectButton = () => {
  const { address } = useAccount();
  const balance = useBalance({ address, unit: 'ether' });

  return (
    <ConnectKitButton.Custom>
      {({ isConnected, show, ensName, truncatedAddress }) => {
        return (
          <StyledConnectButton onClick={show} className={isConnected ? 'connected' : ''}>
            <span className="metamaskIcon">
              <img src={isConnected ? metamaskConnectedIcon : metamaskIcon} alt="Connect" />
            </span>
            <span className="buttonText">{isConnected ? (ensName ? ensName : truncatedAddress) : 'Connect'}</span>
            <span className="balance">
              {balance.data ? Number(formatEther(balance.data.value)).toFixed(3) + ' ETH' : ''}
            </span>
          </StyledConnectButton>
        );
      }}
    </ConnectKitButton.Custom>
  );
};
